import { render, staticRenderFns } from "./Visualizar_Fichero.vue?vue&type=template&id=97c1a896&scoped=true"
import script from "./Visualizar_Fichero.vue?vue&type=script&lang=js"
export * from "./Visualizar_Fichero.vue?vue&type=script&lang=js"
import style0 from "./Visualizar_Fichero.vue?vue&type=style&index=0&id=97c1a896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c1a896",
  null
  
)

export default component.exports